import apiClient from './apiClient';

export interface F936 {
  f936_01: number;  // 月投保薪資
  f936_11: number;  // 保留欄位
  f936_12: number;  // 個人每日勞保費
  f936_13: number;  // 個人每月勞保費
  f936_91: string;
  f936_92: string | null;
  f936_93: string;
}

export interface CreateRequest {
  f936_01: number; f936_11: number; f936_12: number; f936_13: number;
}

export interface UpdateRequest {
  f936_11: number; f936_12: number; f936_13: number;
}

export interface ListResponse { data: F936[]; total: number; page: number; size: number; }

export const laborInsApi = {
  async list(page = 1, size = 500, keyword?: string): Promise<ListResponse> {
    const params: Record<string, string | number> = { page, size };
    if (keyword) params.keyword = keyword;
    return (await apiClient.get('/api/labor-ins', { params })).data;
  },
  async get(salary: number): Promise<F936> {
    return (await apiClient.get(`/api/labor-ins/${salary}`)).data;
  },
  async create(data: CreateRequest): Promise<F936> {
    return (await apiClient.post('/api/labor-ins', data)).data;
  },
  async update(salary: number, data: UpdateRequest): Promise<F936> {
    return (await apiClient.put(`/api/labor-ins/${salary}`, data)).data;
  },
  async delete(salary: number): Promise<void> {
    await apiClient.delete(`/api/labor-ins/${salary}`);
  },
};
